var collapsible_list_component_rtlignore_default = {
  "ltr": "cL1pj",
  "rtl": "aeFZP",
  "iconContainer": "qmvIL",
  "icon": "jQl2j",
  "isExpanded": "UoeLP",
  "listDimensions": "SKw1E"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
